import { TextProps } from "../../types/textTypes";
import "./small.scss";

const Small: React.FC<TextProps> = ({ children, className }) => {
  return <p className={`smallText ${className}`}>{children}</p>;
};

export default Small;
